<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    headeTitle: {
      type: String,
      default: '',
    },
    showDownload: {
      type: Boolean,
      default: false,
    },
    showCreatePlusIcon: {
      type: Boolean,
      default: false,
    },
    routePath: {
      type: String,
      default: '',
    },
    routePathDownload: {
      type: String,
      default: '',
    },
    nsearch: {
      type: String,
      default: '',
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showSearchMenu() {
      this.$emit('showSearchMenu')
    },
  },
}
</script>

<template>
  <b-row align-h="between" :class="$style.menuHeader" class="py-2 mb-3">
    <b-col class="col-12 col-md-6">
      <div v-if="isHtml" class="pageTitle">
        MV<sup>x</sup>–Mortgage VerificationX
      </div>
      <BaseELabel v-else class="pageTitle" :label="headeTitle" />
    </b-col>

    <b-col class="col-12 col-md-4">
      <div class="text-right right-icons my-1">
        <BaseEButton
          v-if="showSearch"
          variant="cancel"
          pre-icon="search"
          @click="showSearchMenu"
        >
          Search
        </BaseEButton>
        <BaseEButton
          v-if="showDownload"
          v-b-tooltip.hover
          variant="cancel"
          pre-icon="download"
          @click="$emit('downloadTo')"
        >
          Download
        </BaseEButton>
      </div>
    </b-col>
  </b-row>
</template>

<style lang="scss" scoped>
/* stylelint-disable selector-pseudo-element-no-unknown */
@import '@design';
::v-deep .pageTitle {
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2rem;
  color: $color-text-primary;
}
</style>

<style lang="scss" module>
@import '@design';
.iconBackground,
.iconBackground:hover {
  padding: 2px 7px 5px;
  background-color: rgba(0, 0, 0, 0.05);
}
.menuHeader {
  background-color: #fff;
}
</style>
